import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot } from '@angular/router'
import { ElderToastService } from '@elderbyte/ngx-starter'
import { EMPTY, Observable } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { Action } from './action'
import { ActionService } from './action.service'

@Injectable({
  providedIn: 'root',
})
export class ActionResolver {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  actionService = inject(ActionService)
  toastService = inject(ElderToastService)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  resolve(route: ActivatedRouteSnapshot): Observable<Action> {
    const id = route.paramMap.get('id')
    return this.actionService.findById(id).pipe(
      catchError((err) => {
        this.toastService.error('messages.loading_failed', err)
        return EMPTY
      })
    )
  }
}
